<div *ngIf="open && successMessage" class="alert alert-dismissible fade show" (close)="successMessage = null" [class.alert-success]="type === 'success'" [class.alert-danger]="type === 'error'" role="alert">
    {{ message | translate }}
    <button type="button" class="close" (click)="hideAlert()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
